/* eslint-disable @typescript-eslint/no-unused-vars */
import { Form } from 'antd';
import { coreActions } from '@sonar-software/sonar-core';
import { MonitorMenu, monitorMenuConfigs } from './MonitorMenu';
import React, { forwardRef, useCallback, useImperativeHandle } from 'react';
import { useAction } from '@hooks';
export const MonitorForm = forwardRef(({ defaultMonitor, editing, form, hideApplications = false, menuOptions, monitor, onChange, showRecommendedActionTemplates = false }, ref) => {
    var _a;
    const patchMonitor = useAction(coreActions.requestPatchCoreDataSecurityMonitorsById);
    const postMonitor = useAction(coreActions.requestPostCoreDataSecurityMonitors);
    const deleteMonitor = useAction(coreActions.requestDeleteCoreDataSecurityMonitorsById);
    const postTemplate = useAction(coreActions.requestPostCoreDataSecurityActionTemplate);
    const handleValidate = useCallback(() => {
        var _a, _b;
        form.validate();
        const currentMonitor = form.getFieldsValue(true);
        if (!currentMonitor || !((_a = currentMonitor.monitorConfig) === null || _a === void 0 ? void 0 : _a.monitorTypeId)) {
            return false;
        }
        const appRequired = (_b = monitorMenuConfigs
            .find((config) => { var _a; return config.type === ((_a = currentMonitor.monitorConfig) === null || _a === void 0 ? void 0 : _a.monitorTypeId); })) === null || _b === void 0 ? void 0 : _b.applicationRequired;
        if (!currentMonitor.templateId) {
            return form.isValid && appRequired ?
                Boolean(currentMonitor.name) && Boolean(currentMonitor.applicationId) :
                Boolean(currentMonitor.name);
        }
        return form.isValid && appRequired ?
            currentMonitor.applicationIds && currentMonitor.applicationIds.length > 0 :
            true;
    }, [form]);
    const saveTemplate = useCallback((overwrite) => {
        const { applicationIds, monitorConfig, stakeholderIds, templateId } = form.getFieldsValue(true);
        postTemplate({
            applicationIds,
            monitorConfig: monitorConfig,
            monitorTypeId: monitorConfig.monitorTypeId,
            overwrite: overwrite,
            stakeholderIds,
            templateId
        });
    }, [form, postTemplate]);
    const saveMonitor = useCallback(() => {
        const { applicationId, monitorConfig, name, notificationSchedule, stakeholderIds } = form.getFieldsValue(true);
        if (monitor === null || monitor === void 0 ? void 0 : monitor.id) {
            const updateMonitor = {
                id: monitor.id,
                monitorConfig,
                name,
                notificationSchedule,
                stakeholderIds
            };
            patchMonitor(updateMonitor);
        }
        else if ((monitorConfig === null || monitorConfig === void 0 ? void 0 : monitorConfig.monitorTypeId) && name) {
            postMonitor({
                applicationId,
                monitorConfig: monitorConfig,
                monitorTypeId: monitorConfig.monitorTypeId,
                name,
                notificationSchedule,
                stakeholderIds
            });
        }
        form.reset();
    }, [form, monitor, patchMonitor, postMonitor]);
    const handleDelete = useCallback(() => {
        if (monitor === null || monitor === void 0 ? void 0 : monitor.id) {
            deleteMonitor({ monitorId: monitor === null || monitor === void 0 ? void 0 : monitor.id });
        }
    }, [deleteMonitor, monitor]);
    const handleOnChange = useCallback((newMonitor) => {
        form.setFieldsValue(newMonitor);
        if (onChange) {
            onChange(newMonitor);
        }
        handleValidate();
    }, [form, handleValidate, onChange]);
    const handleValuesChange = useCallback(() => {
        handleValidate();
        if (onChange) {
            onChange();
        }
    }, [handleValidate, onChange]);
    useImperativeHandle(ref, () => ({
        delete: () => handleDelete(),
        isValid: () => handleValidate(),
        save: () => saveMonitor(),
        saveTemplate: (overwrite) => saveTemplate(overwrite)
    }));
    return (React.createElement(Form, { form: form, layout: 'vertical', name: `monitorForm-${(_a = monitor === null || monitor === void 0 ? void 0 : monitor.id) !== null && _a !== void 0 ? _a : 'new'}`, onValuesChange: handleValuesChange },
        React.createElement(MonitorMenu, { editing: editing, fallbackMonitor: defaultMonitor, hideApplications: hideApplications, menuOptions: menuOptions, monitor: monitor, onChange: handleOnChange, showRecommendedActionTemplates: showRecommendedActionTemplates })));
});
